import { DownOutlined, MessageOutlined, UserOutlined } from "@ant-design/icons";
import { PDFDownloadLink, usePDF } from "@react-pdf/renderer";
import {
  Button,
  Col,
  Collapse,
  Dropdown,
  Input,
  Menu,
  message,
  Modal,
  Steps,
  Typography,
} from "antd";
import Text from "antd/lib/typography/Text";
import moment from "moment";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router";
import {
  UserReportLinkAdv,
  userReportLinkAdvReset,
} from "../../actions/reports/reports";
import Close from "../../assets/icons/close.png";
import {
  amountFormat,
  getBoolVal,
  hasAccess,
  isSuperAdmin,
  objectToFormData,
} from "../../utils";
import BaseCurrency from "../Common/BaseCurrency";
import NoCommentsComponent from "../Common/NoComentsComponent";
import NodataComponent from "../Common/NodataComponent";
import AdvancesTemplatesOne from "../Common/PDF/PDFAdvancesTemplates/AdvancesTemplatesOne";
import {
  advance_pdf,
  advanceApproveReset,
  advanceRejectReset,
  advancesApprove,
  advancesComments,
  advancesCommentsAdd,
  AdvancesCommentsAdd,
  advancesExpDetails,
  advancesExportExcel,
  advancesHistory,
  advancesReject,
  userAdvanceDelete,
  UserAdvanceDelete,
  userAdvancesSubmit,
  userAdvancesSubmitReset,
} from "./../../actions/advances/advances";
import AddAdvance from "./AddAdvance";
import "./advances.css";
import AdvReport from "./AdvReport";
import LinkAdvsToReport from "./LinkAdvsToReport";

const { Panel } = Collapse;
const { TextArea } = Input;
const { Step } = Steps;
const { Title } = Typography;

message.config({
  maxCount: 3,
});

const formatCommentTimestamp = (createdAt) => {
  if (!createdAt) {
    return "-";
  }

  const parsedDate = moment(
    createdAt,
    [
      "DD-MM-YYYY,HH:mm:ss",
      "DD-MM-YYYY, HH:mm:ss",
      "DD-MM-YYYY HH:mm:ss",
      "YYYY-MM-DD HH:mm:ss",
      moment.ISO_8601,
    ],
    true,
  );

  if (parsedDate.isValid()) {
    return parsedDate.format("DD-MM-YYYY, HH:mm:ss");
  }

  const fallbackDate = moment(createdAt);
  return fallbackDate.isValid()
    ? fallbackDate.format("DD-MM-YYYY, HH:mm:ss")
    : createdAt;
};

const AdvanceDetail = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const params = useParams();
  const location = useLocation();
  const [modalType, setIsModalType] = React.useState("center");
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [commentsData, setCommentsData] = React.useState([]);
  const [reasonValue, setReasonValue] = React.useState("");
  const [advancesHistoryData, setAdvancesHistoryData] = React.useState([]);
  const inputComment = React.useRef(null);
  const [input, setInput] = React.useState("");
  const [isURL, setIsURL] = React.useState("");

  // const expensesResponse = useSelector(state => state.advances.advancesExpDetails || {});
  const advancesCommentsResponse = useSelector(
    (state) => state.advances.advancesComments || {},
  );

  const advance_url = useSelector(
    (state) => state.advances.advance_pdf?.data?.response?.advance_url || "",
  );
  const is_admin = useSelector(
    (state) => state?.auth?.localVariables?.is_admin,
  );

  const advanceData = useSelector(
    (state) =>
      state.advances.advancesExpDetails?.data?.response?.advances?.[0] || {},
  );
  const advanceDataLoading = useSelector(
    (state) => state.advances.advancesExpDetails?.loading,
  );
  const advancesCommentsAddResponse = useSelector(
    (state) => state.advances.advancesCommentsAdd || {},
  );
  const advancesRejectResponse = useSelector(
    (state) => state.advances.advancesReject || {},
  );
  const userAdvanceDeleteResponse = useSelector(
    (state) => state.advances.userAdvanceDelete || {},
  );
  const advancesApproveResponse = useSelector(
    (state) => state.advances.advancesApprove || {},
  );
  const advancesExportExcelResponse = useSelector(
    (state) => state.advances.advancesExportExcel || {},
  );
  const advancesHistoryResponse = useSelector(
    (state) => state.advances.advancesHistory || {},
  );
  const userAdvancesSubmitResponse = useSelector(
    (state) => state.advances.userAdvancesSubmit || {},
  );

  const userReportLinkAdvResponse = useSelector(
    (state) => state.reports.userReportLinkAdv || {},
  );

  const [instance, updateInstance] = usePDF({
    document: (
      <AdvancesTemplatesOne
        data={advanceData}
        tripsHistory={advancesHistoryResponse?.data?.response?.history}
        CommentsData={advancesCommentsResponse?.data?.response?.comments}
      />
    ),
  });

  React.useEffect(() => {
    updateInstance(
      <AdvancesTemplatesOne
        data={advanceData}
        tripsHistory={advancesHistoryResponse?.data?.response?.history}
        CommentsData={advancesCommentsResponse?.data?.response?.comments}
      />,
    );
  }, [advanceData, advancesHistoryResponse, advancesCommentsResponse]);

  React.useEffect(() => {
    if (params.id) {
      dispatch(
        advancesExpDetails({
          id: params.id,
          is_admin: getBoolVal(sessionStorage.getItem("is_admin")),
        }),
      );
      dispatch(advance_pdf({ id: params.id }));
      dispatch(
        advancesComments(
          { advance_id: params.id },
          { is_admin: getBoolVal(sessionStorage.getItem("is_admin")) },
        ),
      );
      dispatch(
        advancesHistory(
          { advance_id: params.id },
          { is_admin: getBoolVal(sessionStorage.getItem("is_admin")) },
        ),
      );
    }

    return () => {
      dispatch(userAdvancesSubmitReset());
      dispatch(advanceApproveReset());
      dispatch(advanceRejectReset());
      dispatch(userReportLinkAdvReset());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const { data: { message: res_message = "", status = "" } = {} } =
      userReportLinkAdvResponse;
    if (status) {
      handleCancel();
      dispatch({
        type: UserReportLinkAdv.RESET,
      });
      dispatch(
        advancesExpDetails({
          id: params.id,
          is_admin: getBoolVal(sessionStorage.getItem("is_admin")),
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userReportLinkAdvResponse]);

  // React.useEffect(() => {
  //   const { data: { response: { transactions = [] } = {}, status = "" } = {} } = expensesResponse;
  //   if(status) {
  //     setExpensesData(transactions);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [expensesResponse]);

  React.useEffect(() => {
    const { data: { response: { history = [] } = {}, status = "" } = {} } =
      advancesHistoryResponse;
    if (status) {
      setAdvancesHistoryData(history);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [advancesHistoryResponse]);

  React.useEffect(() => {
    const { data: { response: { comments = [] } = {}, status = "" } = {} } =
      advancesCommentsResponse;
    if (status) {
      setCommentsData(comments);
      setInput("");
      dispatch({
        type: AdvancesCommentsAdd.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [advancesCommentsResponse]);

  React.useEffect(() => {
    const { data: { message: res_message = "", status = "" } = {} } =
      advancesCommentsAddResponse;
    if (status) {
      dispatch(
        advancesComments(
          { advance_id: params.id },
          { is_admin: getBoolVal(sessionStorage.getItem("is_admin")) },
        ),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [advancesCommentsAddResponse]);

  React.useEffect(() => {
    const { data: { message: res_message = "", status = "" } = {} } =
      advancesExportExcelResponse;
    if (status) {
      // dispatch(advancesComments({ advance_id: params.id }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [advancesExportExcelResponse]);

  React.useEffect(() => {
    const { data: { message: res_message = "", status = "" } = {} } =
      advancesRejectResponse;
    if (status) {
      setIsModalVisible(false);
      // dispatch(advances(objectToFormData({ status: true })));
      dispatch(advanceRejectReset());
      dispatch(
        advancesExpDetails({
          id: params.id,
          is_admin: getBoolVal(sessionStorage.getItem("is_admin")),
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [advancesRejectResponse]);

  React.useEffect(() => {
    const { data: { message: res_message = "", status = "" } = {} } =
      userAdvanceDeleteResponse;
    if (status) {
      setIsModalVisible(false);
      dispatch({
        type: UserAdvanceDelete.RESET,
      });
      history.push("/advances");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userAdvanceDeleteResponse]);

  React.useEffect(() => {
    const { data: { message: res_message = "", status = "" } = {} } =
      advancesApproveResponse;
    if (status) {
      // dispatch(advances(objectToFormData({ status: true })));
      dispatch(advanceApproveReset());
      dispatch(
        advancesExpDetails({
          id: params.id,
          is_admin: getBoolVal(sessionStorage.getItem("is_admin")),
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [advancesApproveResponse]);

  React.useEffect(() => {
    const { data: { message: res_message = "", status = "" } = {} } =
      userAdvancesSubmitResponse;
    if (status) {
      dispatch(userAdvancesSubmitReset());
      dispatch(
        advancesExpDetails({
          id: params.id,
          is_admin: getBoolVal(sessionStorage.getItem("is_admin")),
        }),
      );
      // dispatch(trips({ trip_id: tripsData.id }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userAdvancesSubmitResponse]);

  const handleAddComment = () => {
    if (input?.trim() && params.id) {
      dispatch(
        advancesCommentsAdd(
          objectToFormData({
            body: input,
            advance_id: params.id,
          }),
          { is_admin: getBoolVal(sessionStorage.getItem("is_admin")) },
        ),
      );
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const renderRejectDeleteOption = (type) => {
    return (
      <>
        <Text>
          Please specify an appropriate reason for{" "}
          {type === "delete" ? "deletion" : "rejection"}.
        </Text>
        <br />
        <TextArea
          rows={4}
          placeholder="Enter Reason"
          className="reasonTextArea"
          onChange={(e) => setReasonValue(e.target.value)}
          required={true}
        />
        <br />
        <Button
          key="1"
          className="formButton mt1"
          disabled={
            !reasonValue ||
            advancesRejectResponse.loading ||
            userAdvanceDeleteResponse.loading
          }
          onClick={() =>
            type === "delete"
              ? dispatch(
                  userAdvanceDelete(
                    objectToFormData({ id: params.id, reason: reasonValue }),
                  ),
                )
              : dispatch(
                  advancesReject(
                    objectToFormData({ id: params.id, reason: reasonValue }),
                  ),
                )
          }
        >
          Confirm
        </Button>
        <Button
          key="2"
          className="cancelButton ml1 mt1"
          onClick={() => handleCancel()}
        >
          Cancel
        </Button>
      </>
    );
  };

  function handleMenuClick(e) {
    switch (e.key) {
      case "1":
        if (isURL)
          // saveAs(advance_url, "AdvanceDetail.pdf")
          window.open(isURL, "_blank");
        break;
      case "3":
        dispatch(advancesExportExcel({ id: params.id }));
        break;
      default:
    }
  }

  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="1" disabled={!isURL}>
        Download PDF
      </Menu.Item>
      {/* <Menu.Item key="2">Download Receipts</Menu.Item> */}
      {/* <Menu.Item key="3">Export to Excel</Menu.Item> */}
      {/* <Menu.Item key="4">Print</Menu.Item>  */}
    </Menu>
  );

  const showLinkModal = (id) => {
    setIsModalVisible(true);
    setIsModalType("addUnrepExp");
  };

  const showEditModal = (id) => {
    setIsModalVisible(true);
    setIsModalType("addAdvanceModal");
  };

  const showRejectModal = (id) => {
    setIsModalVisible(true);
    setIsModalType("rejectModal");
  };

  const showDeleteModal = (id) => {
    setIsModalVisible(true);
    setIsModalType("DeleteModal");
  };

  const renderUnrepOption = () => {
    return (
      <>
        <LinkAdvsToReport adv_id={params.id} />
      </>
    );
  };

  const renderModalData = (type) => {
    switch (type) {
      case "addUnrepExp":
        return renderUnrepOption();
      case "rejectModal":
        return renderRejectDeleteOption("reject");
      case "DeleteModal":
        return renderRejectDeleteOption("delete");
      case "addAdvanceModal":
        return (
          <AddAdvance
            handleCancel={() => {
              setIsModalVisible(false);
              history.push("/advances");
            }}
            advanceData={advanceData}
          />
        );
      default:
        return "";
    }
  };

  const renderModalTitle = (type) => {
    switch (type) {
      case "addUnrepExp":
        return "Add Advance to Report";
      case "rejectModal":
        return "Reject Advance";
      case "DeleteModal":
        return "Delete Advance";
      case "addAdvanceModal":
        return (
          <Title level={4}>
            Edit Fields &nbsp;
            <span className="text-small">Enter details and submit</span>
          </Title>
        );
      default:
        return "";
    }
  };

  const renderModalClass = (type) => {
    switch (type) {
      case "addUnrepExp":
        return "right-alinged-modal";
      case "rejectModal":
        return "center-aligned-modal";
      case "DeleteModal":
        return "center-aligned-modal";
      case "addAdvanceModal":
        return "right-alinged-modal";
      default:
        return "";
    }
  };
  const emp_id = sessionStorage.getItem("employee_id");

  React.useEffect(() => {
    if (!instance.loading && instance.url) {
      setIsURL(instance.url);
    }
  }, [instance]);
  return (Array.isArray(advanceData?.advance_approvers_data) &&
    advanceData?.advance_approvers_data?.includes(emp_id)) ||
    is_admin ||
    advanceDataLoading ? (
    <div className="advance-detail detail-card mb4">
      <Modal
        title={renderModalTitle(modalType)}
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={[]}
        className={renderModalClass(modalType)}
      >
        {renderModalData(modalType)}
      </Modal>
      <section className="head">
        <div className="flex-between">
          <div className="v-center">
            <h3>{advanceData.title}</h3>
            <span
              className={`status status_${
                is_admin
                  ? advanceData?.current_advance_status
                  : advanceData?.status
              }`}
            >
              {is_admin
                ? advanceData?.current_advance_status?.replace(/_/g, " ")
                : advanceData?.status?.replace(/_/g, " ")}
            </span>
          </div>
          <div className="d-flex action-btns">
            {getBoolVal(sessionStorage.getItem("is_admin")) ? (
              <>
                {hasAccess("advances", "write") &&
                (!advanceData?.action_restrict || isSuperAdmin()) &&
                advanceData?.current_advance_status === "pending_approval" ? (
                  <>
                    <button
                      className="approve"
                      disabled={advancesApproveResponse?.loading}
                      onClick={() =>
                        dispatch(
                          advancesApprove(objectToFormData({ id: params.id })),
                        )
                      }
                    >
                      Approve
                    </button>

                    <button
                      className="reject"
                      onClick={() => showRejectModal(params.id)}
                    >
                      Reject
                    </button>
                  </>
                ) : null}{" "}
              </>
            ) : (
              <>
                {hasAccess("advances", "write") &&
                advanceData.status === "unsubmitted" ? (
                  <>
                    <button
                      className="approve"
                      disabled={userAdvancesSubmitResponse?.loading}
                      onClick={() =>
                        dispatch(
                          userAdvancesSubmit(
                            objectToFormData({ advance_id: params.id }),
                            {
                              is_admin: getBoolVal(
                                sessionStorage.getItem("is_admin"),
                              ),
                            },
                          ),
                        )
                      }
                    >
                      Submit
                    </button>
                    <button
                      className="reject"
                      onClick={() => showEditModal(params.id)}
                    >
                      Edit
                    </button>
                    <button
                      className="delete"
                      onClick={() => showDeleteModal(params.id)}
                    >
                      Delete
                    </button>
                  </>
                ) : null}
              </>
            )}

            {hasAccess("advances", "write") &&
              !is_admin &&
              advanceData.status === "approved" && (
                <Button
                  onClick={() => showLinkModal(params.id)}
                  className="floatRight ml1 primaryButton"
                >
                  Add to Report
                </Button>
              )}
            {hasAccess("advances", "write") &&
              !is_admin &&
              advanceData?.recallable &&
              advanceData.status === "pending_approval" && (
                <Button
                  onClick={() => {
                    dispatch(
                      userAdvancesSubmit({ id: params.id, isRecall: true }),
                    );
                  }}
                  className="floatRight ml1 primaryButton"
                >
                  Recall
                </Button>
              )}

            <Dropdown overlay={menu} placement="bottomRight">
              <button className="more">
                More&nbsp;
                <DownOutlined />
              </button>
            </Dropdown>

            <span
              className="close cursor"
              onClick={() => {
                history.push("/advances", {
                  filter: location.state.filter,
                });
              }}
            >
              <img src={Close} width={20} alt={"close"} />
            </span>
          </div>
        </div>
        <div>
          <span className="duration">
            Submitted on : {advanceData.submitted_on}
          </span>
        </div>
      </section>
      <hr />
      {getBoolVal(sessionStorage.getItem("is_admin")) ? (
        <section className="advance-info">
          <div className="title-card d-flex">
            <p>
              <span>
                Submitted by :<br />
                {advanceData.submitted_by}
              </span>
              <span className="sm">on {advanceData.submitted_on}</span>
            </p>
            <p>
              <span>
                Submitted to :<br />
              </span>
              <span>
                {advanceData.submitted_to_email || advanceData.submitted_to}
              </span>
            </p>
            {advanceData?.status === "pending_approval" && (
              <p>
                <span>
                  Pending approval :<br />
                </span>
                <span className="dim">
                  {advanceData.pending_approval_by || advanceData?.email}
                </span>
              </p>
            )}
          </div>
          <div className="advance-total title-card">
            <p>
              <label>Advance Amount</label>
              <span className="lg">
                <BaseCurrency /> {amountFormat(advanceData.amount) || 0}
              </span>
            </p>
            <p></p>
          </div>
        </section>
      ) : (
        <>
          <section className="advance-info">
            <div className="advance-total-user title-card-user">
              <p>
                <label>Advance Amount</label>
                <span className="lg">
                  <BaseCurrency /> {amountFormat(advanceData.amount) || 0}
                </span>
              </p>
              <p></p>
            </div>
          </section>
          <section className="advance-info">
            <div className="advance-total-user title-card-user">
              <Col span={4} className="boidPs">
                <p>Date:</p>
                <p>Reference#:</p>
                <p>Recorded by:</p>

                {advanceData?.status === "pending_approval" && (
                  <>
                    <p>Submitted To:</p>
                    <p>Pending Approval:</p>
                  </>
                )}
              </Col>
              <Col span={10}>
                <p>{advanceData.date}</p>
                <p>{advanceData.reference_no}</p>
                <p>{advanceData.submitted_by}</p>
                {advanceData?.status === "pending_approval" && (
                  <>
                    <p>{advanceData.submitted_to}</p>
                    <p>{advanceData.pending_approval_by}</p>
                  </>
                )}
              </Col>
            </div>
          </section>
        </>
      )}
      <section className="business-info">
        <div className="title-card">
          {advanceData?.custom_fields?.map(({ key, value }) => (
            <p>
              <span className="capitalize">{key?.replace(/_/g, " ")}:</span>
              <span className="dim">{value || "_"}</span>
            </p>
          ))}
        </div>
      </section>
      <div className="ml2 mr2 mt1 mb1">
        <Collapse
          bordered={false}
          defaultActiveKey={
            getBoolVal(sessionStorage.getItem("is_admin")) ? ["1"] : ["3"]
          }
        >
          {/* <Panel header={<span>Advances</span>} key="14">
            {advanceData && <Expenses expensesData={advanceData} />}
          </Panel> */}
          {/* {getBoolVal(sessionStorage.getItem("is_admin")) ? ( */}
          <Panel
            header={
              <span>
                Associated Reports {advanceData.report && <strong>{1}</strong>}
              </span>
            }
            key="2"
          >
            {advanceData && advanceData.report ? (
              <AdvReport repData={advanceData.report} />
            ) : (
              // <div>
              //   <p>
              //     Apply this advance to the report which has expenses incurred
              //     using this advance.
              //   </p>
              //   <Button key="1" className="ml1 primaryButton">
              //     Apply to Report
              //   </Button>
              // </div>
              <NodataComponent />
            )}
          </Panel>
          {/* ) : null} */}
          <Panel
            header={
              <span>
                Comments <strong>{commentsData.length}</strong>
              </span>
            }
            key="3"
          >
            <div className="addComment mt2 mb1">
              <Input
                placeholder="Enter Comment"
                ref={inputComment}
                value={input}
                onChange={(e) => setInput(e.target.value.trimStart())}
              />
              <Button
                key="1"
                className="formButton ml1"
                onClick={() => handleAddComment()}
              >
                Send
              </Button>
            </div>
            {commentsData.length ? (
              <>
                <div className="commentsSection mt2">
                  <Steps
                    direction="vertical"
                    size="small"
                    current={commentsData.length + 1 || 100}
                  >
                    {commentsData &&
                      commentsData.map(
                        ({ body, created_at, user_name, id }) => (
                          <Step
                            key={id}
                            title={body}
                            description={
                              formatCommentTimestamp(created_at) +
                              " / " +
                              user_name
                            }
                            icon={<MessageOutlined />}
                          />
                        ),
                      )}
                  </Steps>
                </div>
              </>
            ) : (
              <NoCommentsComponent />
            )}
          </Panel>
          {/* {getBoolVal(sessionStorage.getItem("is_admin")) ? ( */}
          <Panel
            header={
              <span>
                History <strong>{advancesHistoryData.length}</strong>
              </span>
            }
            key="4"
          >
            {advancesHistoryData.length ? (
              <div className="commentsSection mt2">
                <Steps
                  direction="vertical"
                  size="small"
                  current={advancesHistoryData.length + 1 || 100}
                >
                  {advancesHistoryData &&
                    advancesHistoryData.map(
                      ({ body, created_at, user_name, id, status }) => (
                        <Step
                          key={id}
                          title={body}
                          description={
                            formatCommentTimestamp(created_at) +
                            " | " +
                            user_name +
                            " | Action: " +
                            status
                          }
                          icon={<UserOutlined />}
                        />
                      ),
                    )}
                </Steps>
              </div>
            ) : (
              <NodataComponent />
            )}
          </Panel>
          {/* ) : null} */}
        </Collapse>
      </div>
    </div>
  ) : (
    <div className="advance-detail detail-card mb4">
      {`You don't have permissions to view this advance`}
    </div>
  );
};

export default AdvanceDetail;
